// extracted by mini-css-extract-plugin
export default {"menudivider":"index_menudivider__T7vjI","infotitle":"index_infotitle__FmPcf","footerbg":"index_footerbg__aDuL8"};